/**
 * Retrieves properly typed object keys
 * @param obj
 */
export function objectKeys<T extends Record<string, unknown>>(obj: T) {
    return Object.keys(obj) as (keyof T)[];
}

export function objectEntries<T extends Record<string, unknown>>(obj: T) {
    return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
}
